import styled from 'styled-components';
import {WP_CONTENT_PREFIX} from '../constants';

export const PixeledFont = styled.div`
    @font-face {
        font-family: Pixel Coleco;
        src: url('${`${WP_CONTENT_PREFIX}/fonts/PixelColeco.otf`}') format('opentype');
    }
`;
